<template>
  <div class="formulario h2-defaultMuni" @keyup.enter="aplicarFiltro">
    <div class="input-wrapper">
      <input v-model="numeroTramite" placeholder="Número del trámite" />
      <span v-if="numeroTramite" @click="numeroTramite = ''" class="clear-button">&times;</span>
    </div>

    <div class="input-wrapper">
      <SearchableSelect :disabledItems="[procedure]" :searchFunction="ProcedureHandler.searchByQuery" :selected="procedure"
        :useLastAsPlaceholder="true" :placeholderKey="['title']"  @keyup.enter="aplicarFiltro"
        defaultPlaceholder="Nombre o descripción del Trámite" @select="(v) => procedure = v" :overlayDropdown="true">
        <template #default="{ option }">
          <div class="status-item-container">
            <span class="h3-heroMuni">{{ option.title }}</span>
          </div>
        </template>
      </SearchableSelect>
      <span v-if="procedure" @click="procedure = null" class="clear-button">&times;</span>
    </div>

    <div class="input-wrapper">
      <SearchableSelect :disabledItems="[user]" :searchFunction="UserHandler.searchByQuery" :selected="user"
        :useLastAsPlaceholder="true" :placeholderKey="['firstname', 'lastname']"
        defaultPlaceholder="Nombre o Cuil del Vecino" @select="(v) => (user = v)" :overlayDropdown="true">
        <template #default="{ option }">
          <div class="status-item-container">
            <span class="h3-heroMuni">{{ option.firstname }} {{ option.lastname }}</span>
          </div>
        </template>
      </SearchableSelect>
      <span v-if="user" @click="user = null" class="clear-button">&times;</span>
    </div>

    <!-- <div class="input-wrapper">
      <input v-model="cuilVecino" placeholder="Cuil del Vecino" />
      <span v-if="cuilVecino" @click="cuilVecino = ''" class="clear-button">&times;</span>
    </div> -->

    <div class="input-wrapper">
      <PickadayComponent v-model="fechasSeleccionadas" :maxDate="new Date()" />
      <span v-if="fechasSeleccionadas.length > 0" @click="fechasSeleccionadas = []" class="clear-button">&times;</span>
    </div>

    <div class="input-wrapper">
      <SearchableSelect :options="procedureStatuses" :disabledItems="status" :filterKeys="['title']" :selected="status"
        placeholderKey="title" defaultPlaceholder="Estado del Trámite" @select="
          (v) => {
            if (!status) status = [];
            status.push(v);
          }
        " :overlayDropdown="true">
        <template #default="{ option }">
          <div class="status-item-container">
            <div class="status-circle" :style="{ backgroundColor: option.color }"></div>
            <span class="h3-heroMuni">{{ option.title }}</span>
          </div>
        </template>
      </SearchableSelect>
      <span v-if="status?.length > 0" @click="status = []" class="clear-button">&times;</span>
    </div>

    <div class="ListContainer" v-if="status?.length > 0">
      <div v-for="(tag, index) in status" :key="index" @click="status.splice(index, 1)" class="ListItem">
        <div class="status-circle" :style="{ backgroundColor: tag.color }"></div>
        <span class="h3-heroMuni">{{ tag.title }}</span>
        <span>&times;</span>
      </div>
    </div>

    <div class="input-wrapper">
      <SearchableSelect :options="areas" :disabledItems="[area]" :filter-keys="['area_name']" :selected="area"
        :useLastAsPlaceholder="true" placeholderKey="area_name" defaultPlaceholder="Áreas" @select="(v) => (area = v)"
        :overlayDropdown="true">
        <template #default="{ option }">
          <div class="status-item-container">
            <span class="h3-heroMuni">{{ option.area_name }}</span>
          </div>
        </template>
      </SearchableSelect>
      <span v-if="area" @click="area = null" class="clear-button">&times;</span>
    </div>

    <div class="input-wrapper" v-if="store?.state?.user?.role !== 'MUNI_ROLE'">
      <SearchableSelect :options="munis" :disabledItems="[muni]" :filter-keys="['firstname', 'lastname']"
        :selected="muni" :useLastAsPlaceholder="true" :placeholderKey="['firstname', 'lastname']"
        defaultPlaceholder="Agente Responsable" @select="(v) => (muni = v)" :overlayDropdown="true">
        <template #default="{ option }">
          <div class="status-item-container">
            <span class="h3-heroMuni">{{ option.firstname }} {{ option.lastname }}</span>
          </div>
        </template>
      </SearchableSelect>
      <span v-if="muni" @click="muni = null" class="clear-button">&times;</span>
    </div>

    <div class="btnsSection">
      <button @click="aplicarFiltro" class="actionBtn h2-heroMuni" style="background-color: var(--color-success)">
        Aplicar
      </button>
      <button @click="limpiarFiltro" class="actionBtn h2-heroMuni" style="background-color: var(--color-error)">
        Limpiar
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { SearchableSelect } from "procedures-engine";
import PickadayComponent from "@/components/Utils/PickadayComponent.vue";
// import SearchableSelect from "@/components/Utils/SearchableSelect.vue";
import UserHandler from "@/services/handlers/UserHandler";
import { useRouter } from "vue-router";
import ProcedureHandler from "@/services/handlers/ProcedureHandler";

// Props recibidas del orquestador para no volver a llamar a la API
const props = defineProps({
  areas: { type: Array, default: () => [] },
  munis: { type: Array, default: () => [] },
  channels: { type: Array, default: () => [] },
});

const emit = defineEmits(["close-modal"]);
const store = useStore();
const router = useRouter();

// --- ESTADOS LOCALES ---
const status = ref([]);
const numeroTramite = ref("");
const procedure = ref("");
const user = ref(null);
const fechasSeleccionadas = ref([]);
const area = ref(null);
const muni = ref(null);
const channel = ref(null);

const procedureStatuses = ref([
  { value: "PRESENTADO", title: "Nuevo", color: "#00C3A8" },
  { value: "EN PROCESO", title: "En Proceso", color: "#00C3A8" },
  { value: "REQUERIDO", title: "Requerido", color: "#FFB900" },
  { value: "FUERA DE PLAZO", title: "Fuera de Plazo", color: "var(--color-error)" },
  { value: "FINALIZADO", title: "Finalizado", color: "var(--text-muted)" },
]);

// --- CARGA DESDE STORE ---
const loadFiltersFromStore = async () => {
  const filters = store.state.filters["tramites"] || {};

  status.value = filters.status
    ? (procedureStatuses.value.filter((t) =>
      filters.status?.some((s) => s === t.value),
    ) ?? null)
    : null;

  numeroTramite.value = filters.procedureId ?? "";

  fechasSeleccionadas.value = [];
  if (filters.fromDate) fechasSeleccionadas.value[0] = filters.fromDate;
  if (filters.toDate) fechasSeleccionadas.value[1] = filters.toDate;

  // Lógica de Area y Muni (dependen de props, que pueden tardar un poco, usamos optional chaining)
  muni.value = filters.userMuni
    ? (props.munis?.find((m) => m.id === filters.userMuni) ?? null)
    : // : props.munis?.find((m) => m.id === store.state?.user?.id);
    null;

  channel.value = filters.channel
    ? (props.channels?.find((c) => c.value === filters.channel) ?? null)
    : null;

  area.value = filters.area
    ? (props.areas?.find((c) => c.area_name === filters.area) ?? null)
    : null;

  // Hidratación asíncrona de usuario
  user.value = null;
  if (filters.userId) {
    try {
      const foundUsers = await UserHandler.searchByQuery(
        filters.userId.toString(),
      );
      if (foundUsers && foundUsers.length > 0) {
        user.value = foundUsers.find((u) => u.id == filters.userId) || null;
      }
    } catch (error) {
      console.error("Error hidratando usuario:", error);
    }
  }
  // Hidratación asíncrona de procedure
  procedure.value = null;
  if (filters.templateId) {
    try {
      const foundProcedures = await ProcedureHandler.searchByQuery(
        filters.templateId.toString(),
      );
      if (foundProcedures && foundProcedures.length > 0) {
        procedure.value =
          foundProcedures.find((u) => u.id == filters.templateId) || null;
      }
    } catch (error) {
      console.error("Error hidratando usuario:", error);
    }
  }
};

onMounted(() => {
  loadFiltersFromStore();
});

// --- ACCIONES ---
function aplicarFiltro() {
  const condiciones = {};
  if (status.value) condiciones.status = status.value.map((s) => s.value);
  if (numeroTramite.value)
    condiciones.procedureId = parseInt(numeroTramite.value);
  if (procedure.value) condiciones.templateId = procedure.value.id;
  if (fechasSeleccionadas.value[0])
    condiciones.fromDate = fechasSeleccionadas.value[0];
  if (fechasSeleccionadas.value[1])
    condiciones.toDate = fechasSeleccionadas.value[1];
  if (muni.value) condiciones.userMuni = muni.value.id;
  if (channel.value) condiciones.channel = channel.value.value;
  if (area.value) condiciones.area = area.value.area_name;
  if (user.value) condiciones.userId = user.value.id;

  if (Object.keys(condiciones).length === 0) return;

  if (document.activeElement) {
    document.activeElement.blur(); //quita foco del input
  }
  console.log("FILTRO:", condiciones);
  store.dispatch("setFiltersAction", { seccion: "tramites", condiciones });
  router.push({ name: "home-agentes" });
  emit("close-modal");
}

function limpiarFiltro() {
  status.value = [];
  numeroTramite.value = "";
  procedure.value = "";
  fechasSeleccionadas.value = [];
  muni.value = null;
  channel.value = null;
  area.value = null;
  user.value = null;

  store.dispatch("clearFiltersAction", "tramites");
  emit("close-modal");
}

watch(
  [() => props],
  () => {
    loadFiltersFromStore();
  },
  { deep: true },
);
</script>
